import { publicAxios } from "../../../config/apiConfig";
import {
  GET_ALL_CURRENCY_SUCCESS,
  GET_ALL_CURRENCY_REQUEST,
  GET_ALL_CURRENCY_FAILURE,
} from "./ActionType";

export const getAllCurrency = () => async (dispatch) => {
  dispatch({ type: GET_ALL_CURRENCY_REQUEST });
  try {
    const { data } = await publicAxios.get(`currencies`);
    dispatch({ type: GET_ALL_CURRENCY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_CURRENCY_FAILURE, payload: error.message });
  }
};
